import { useCompanySettingsInfo } from './useCompanySettingsInfo';

/**
 * Returns the dynamic currency symbol from company settings.
 * Falls back to "" when settings are not yet loaded.
 */
export function useCurrencySymbol(): string {
  const { data: settings } = useCompanySettingsInfo();
  return settings?.currency_short_title || '';
}
